/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef, Row } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import React, { useState } from 'react';
// eslint-disable-next-line import/no-cycle
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Checkbox, Grid } from '@mui/material';
import { handleGlobalCheckboxValueInputChange } from '../store/table-slice';
import { handleglobalheadercheckboxstate } from '../store/table-slice';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import CheckboxInput from '../../../../pricing-simulator/components/table-columns/chekbox-input';

export default function getColumnForCheckboxType(
  columnData: Header,
  columnMetadata: Header[],
  componentType: TableComponent,
  maxVal?: number,
  inputsDisabled?: boolean,
  isDisplayHeader?: boolean
) {
  const subHeader: ColumnDef<{ [key: string]: number | string }> = {
    accessorKey: columnData.parent.parent_field || 'checkbox_field',
    header: (props) => {
      const appDispatch = useAppDispatch();
      const [value, setValue] = useState<number>();
      const globalHeaderState = useAppSelector(
        (state) => state.table.globalHeaderState
      );
      const currentHeaderValue = globalHeaderState[columnData.parent.parent_field];
      const handleValueChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
      ) => {
        setValue(checked ? 1 : 0);
        appDispatch(
          handleGlobalCheckboxValueInputChange({
            columnMetadata: columnData,
            newValue: checked ? 1 : 0
          })
        );
        appDispatch(
          handleglobalheadercheckboxstate({
            columnMetadata: columnData,
            newValue: checked ? 1 : 0
          })
        );
      };
      return (
        <Grid container alignItems='center' flexDirection='column'>
          <Grid
            item
            xs='auto'
            container
            alignItems='center'
            className='change-text'
          >
            {isDisplayHeader ? (
              <Grid item sx={{ cursor: 'pointer' }}>
                {columnData.parent.alias}
                {getHeaderName(columnData)}
              </Grid>
            ) : null}
          </Grid>
          {columnData.parent.field_format === InputType.CHECKBOX &&
            columnData.parent.is_global_input_enable === true && (
              <Grid item xs='auto' style={{ margin: 'auto' }}>
                <Checkbox
                  checked={currentHeaderValue === 1}
                  value={currentHeaderValue === 1}
                  onChange={handleValueChange}
                  size='small'
                  disabled={inputsDisabled}
                  placeholder='-'
                />
              </Grid>
            )}
        </Grid>
      );
    },
    meta: {
      className:
        columnData.parent.order === maxVal || maxVal === undefined
          ? 'last checkbox-input'
          : ''
    },
    cell: ({
      cell,
      row
    }: {
      cell: any;
      row: Row<{ [key: string]: string | number }>;
    }) => {
      const idColumns: Header[] = columnMetadata
        .filter(
          (data) =>
            !data.parent.is_visible &&
            data.parent.field_format === InputType.NUMBER
        )
        .sort((a, b) => a.parent.level - b.parent.level);
      const isExpand = TableComponent.MULTIYEARESTIMATE !== componentType;
      const { summary: summaryAccessConfig } = useAppSelector(
        (state) => state.simulatorHome.moduleAccessMap
      );
      if (TableComponent.MULTIYEARESTIMATE === componentType) {
        const isParent = !row.getParentRow();
        if (isParent) {
          return <span>-</span>;
        }
        if (row.index === 0) {
          return <span>-</span>;
        }
      }
      return (
        <CheckboxInput
          row={row}
          uniqueIDColumns={idColumns}
          columnMetadata={columnData}
          componentType={componentType}
          inputsDisabled={
            inputsDisabled ||
            (TableComponent.MULTIYEARESTIMATE === componentType &&
              !summaryAccessConfig?.provide_inputs_multi_year_estimate)
          }
        />
      );
    }
  };
  return subHeader;
}
